import { useEffect, useRef, useState } from 'react';

const SCRAMBLE_CHARS = '0123456789#'.split('');
const SCRAMBLE_SPEED = 50;

export const useScrambleText = (targetText: string, duration: number, delay: number) => {
  const [displayText, setDisplayText] = useState(() => {
    return targetText.replace(/[^-]/g, '#');
  });
  const requestRef = useRef<number>(0);
  const startTimeRef = useRef<number | null>(null);
  const lastUpdateRef = useRef<number>(0);

  useEffect(() => {
    // Reset Refs if targetText changes
    startTimeRef.current = null;
    lastUpdateRef.current = 0;

    const animate = (currentTime: number) => {
      if (startTimeRef.current === null) {
        startTimeRef.current = currentTime;
      }

      const elapsed = currentTime - startTimeRef.current;
      const progress = Math.min(elapsed / duration, 1);

      if (progress < 1) {
        if (currentTime - lastUpdateRef.current > SCRAMBLE_SPEED) {
          const scrambled = targetText
            .split('')
            .map((char) => {
              if (char === ' ' || char === '-') {
                return char;
              }
              return SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)];
            })
            .join('');

          setDisplayText(scrambled);
          lastUpdateRef.current = currentTime;
        }
        requestRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayText(targetText);
      }
    };

    const timer = setTimeout(() => {
      requestRef.current = requestAnimationFrame(animate);
    }, delay);

    return () => {
      clearTimeout(timer);
      cancelAnimationFrame(requestRef.current);
    };
  }, [targetText, duration, delay]);

  return displayText;
};
